import React from 'react';
import { string } from 'prop-types';
import { SiteFooter as SiteFooter$1 } from '@tesla/design-system-react';
import { parseLocale } from '@tesla/parse-locale';
import translationMappings from './translations/index.js';
import TtpProvider from '../TtpProvider/index.js';
import '../PageWrapper/Navigation/pages.js';
import '../../utils/googleAnalytics/index.js';
import 'lodash/uniq';
import 'lodash/compact';
import '@tesla/format-number';
import { useTtp } from '../../utils/ttp/index.js';
import { getLocalizeUrl } from '../../utils/url/index.js';
import '@babel/runtime/helpers/slicedToArray';
import styles from './styles.module.css.js';

var SiteFooter = function SiteFooter(_ref) {
  var baseUrl = _ref.baseUrl,
    locale = _ref.locale;
  var translate = useTtp();
  var languageCode = parseLocale(locale).lang;
  var currentLocale = locale.toLowerCase();
  var date = new Date();
  var currentYear = date.getFullYear();
  var aboutCopy = "Tesla \xA9 ".concat(currentYear);
  var isKR = currentLocale === 'ko_kr';
  var legalLink = isKR ? "".concat(baseUrl).concat(getLocalizeUrl('/legal/privacy?redirect=no', locale)) : "".concat(baseUrl).concat(getLocalizeUrl('/legal?redirect=no', locale));
  return /*#__PURE__*/React.createElement(TtpProvider, {
    value: translationMappings(locale)
  }, /*#__PURE__*/React.createElement(SiteFooter$1, {
    align: "center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "".concat(baseUrl).concat(getLocalizeUrl('/about?redirect=no', locale)),
    title: aboutCopy,
    "aria-label": aboutCopy,
    className: "tds-link tds-link--secondary"
  }, aboutCopy), currentLocale === 'zh_cn' ? /*#__PURE__*/React.createElement("a", {
    href: "https://beian.miit.gov.cn",
    title: "\u6CAAICP\u59072021004806\u53F7-1",
    "aria-label": "\u6CAAICP\u59072021004806\u53F7-1",
    className: "tds-link tds-link--secondary"
  }, "\u6CAAICP\u59072021004806\u53F7-1") : null, currentLocale === 'zh_cn' ? /*#__PURE__*/React.createElement("a", {
    href: "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502017892",
    title: "\u6CAA\u516C\u7F51\u5B89\u5907 31011502017892 \u53F7",
    "aria-label": "\u6CAA\u516C\u7F51\u5B89\u5907 31011502017892 \u53F7",
    className: "tds-link tds-link--secondary"
  }, "\u6CAA\u516C\u7F51\u5B89\u5907 31011502017892 \u53F7") : null, currentLocale === 'zh_cn' ? /*#__PURE__*/React.createElement("a", {
    href: "https://www.tesla.cn/businesslicense",
    title: "\u8425\u4E1A\u6267\u7167",
    "aria-label": "\u6CAA\u516C\u7F51\u5B89\u5907 31011502017892 \u53F7",
    className: "tds-link tds-link--secondary"
  }, "\u8425\u4E1A\u6267\u7167") : null, /*#__PURE__*/React.createElement("a", {
    href: "".concat(legalLink),
    title: translate('privacy'),
    "aria-label": translate('privacy'),
    className: "tds-link tds-link--secondary ".concat(currentLocale === 'ko_kr' ? styles.PrivacyLink : undefined)
  }, translate('privacy')), languageCode === 'de' && /*#__PURE__*/React.createElement("a", {
    href: "".concat(baseUrl).concat(getLocalizeUrl('/impressum?redirect=no', locale)),
    title: translate('impressum'),
    "aria-label": translate('impressum'),
    className: "tds-link tds-link--secondary"
  }, translate('impressum')), currentLocale === 'en_au' ? /*#__PURE__*/React.createElement("a", {
    href: "".concat(baseUrl).concat(getLocalizeUrl('/support/annual-and-recall-service', locale)),
    title: translate('recallInfo'),
    "aria-label": translate('recallInfo'),
    className: "tds-link tds-link--secondary"
  }, translate('recallInfo')) : null, currentLocale === 'zh_cn' ? /*#__PURE__*/React.createElement("a", {
    href: "".concat(baseUrl).concat(getLocalizeUrl('/contact', locale)),
    title: "contact",
    "aria-label": "contact",
    className: "tds-link tds-link--secondary"
  }, "\u8054\u7CFB\u6211\u4EEC") : null, currentLocale === 'zh_cn' ? /*#__PURE__*/React.createElement("a", {
    href: "".concat(baseUrl).concat(getLocalizeUrl('/careers', locale)),
    title: "careers",
    "aria-label": "careers",
    className: "tds-link tds-link--secondary"
  }, "\u5DE5\u4F5C\u673A\u4F1A") : null, currentLocale === 'zh_cn' ? /*#__PURE__*/React.createElement("a", {
    href: "".concat(baseUrl).concat(getLocalizeUrl('/blog', locale)),
    title: "blog",
    "aria-label": "blog",
    className: "tds-link tds-link--secondary"
  }, "\u6700\u65B0\u6D88\u606F") : null), currentLocale === 'ko_kr' && /*#__PURE__*/React.createElement("ul", {
    className: "tds-list"
  }, /*#__PURE__*/React.createElement("li", {
    className: "tds-list-item ".concat(styles.Disclaimer)
  }, "\uD14C\uC2AC\uB77C\uCF54\uB9AC\uC544 \uC720\uD55C\uD68C\uC0AC | \uC0AC\uC5C5\uC790\uB4F1\uB85D\uBC88\uD638 : 524-88-00237 | \uB370\uC774\uBE44\uB4DC\uC874\uD30C\uC778\uC2A4\uD0C0\uC778, \uCF00\uB124\uC2A4\uC5B4\uB2C8\uC2A4\uD2B8\uBB34\uC5B4 | \uD1B5\uC2E0\uD310\uB9E4\uC5C5\uC2E0\uACE0: \uC81C2016-\uC11C\uC6B8\uAC15\uB0A8-02964\uD638 |", ' ', /*#__PURE__*/React.createElement("a", {
    className: "tds-link",
    href: "https://www.ftc.go.kr/bizCommPop.do?wrkr_no=5248800237",
    title: "\uC0AC\uC5C5\uC790\uC815\uBCF4\uD655\uC778",
    "aria-label": "link"
  }, "\uC0AC\uC5C5\uC790\uC815\uBCF4\uD655\uC778"), ' ', "| \uC8FC\uC18C : \uC11C\uC6B8\uD2B9\uBCC4\uC2DC \uAC15\uB0A8\uAD6C \uD14C\uD5E4\uB780\uB85C 134, 14\uCE35 | \uB300\uD45C\uC804\uD654 :", ' ', /*#__PURE__*/React.createElement("a", {
    href: "tel:080-617-1388",
    "aria-label": "telephone"
  }, "080-617-1388"), ' ', "|", ' ', /*#__PURE__*/React.createElement("a", {
    className: "tds-link",
    href: "mailto:southkorea@tesla.com",
    "aria-label": "email"
  }, "southkorea@tesla.com"))));
};
SiteFooter.propTypes = {
  baseUrl: string,
  locale: string
};
SiteFooter.defaultProps = {
  baseUrl: '',
  locale: 'en_us'
};

/**
 * Global navigation footer
 * @extends {Component<Props>}
 */
var Wrapper = function Wrapper(_ref2) {
  var baseUrl = _ref2.baseUrl,
    locale = _ref2.locale;
  return /*#__PURE__*/React.createElement(TtpProvider, {
    value: translationMappings(locale)
  }, /*#__PURE__*/React.createElement(SiteFooter, {
    baseUrl: baseUrl,
    locale: locale
  }));
};
Wrapper.propTypes = {
  baseUrl: string,
  /** Geographic locale in ll_cc format */
  locale: string
};
Wrapper.defaultProps = {
  baseUrl: '',
  locale: 'en_us'
};

export { Wrapper as default };
